import { Dialog } from '@headlessui/react';
import { XMarkIcon } from '@heroicons/react/24/outline';
import { FlexRow } from "src/utils/flexLayouts";
import { FavoriteButtonFilters } from "src/modules/mt/FavoriteButtonFilters.mobile";
import { FiveWhyType } from "src/api/config/systemSwitch";
import { FavoriteFiltersList } from "src/modules/mt/FavoriteFiltersList.mobile";
import { myTasks5WayWithRelationsListName } from "src/api/config/myTasks5Way.config";

type FilterActionsProps = {
  isOpen: boolean;
  children: React.ReactNode;
  onClose: () => void;
  onResetFilters: () => void;
  filters?: any;
  displayFilters?: any;
  reRenderFilterSettings?: any;
  setReRenderFilterSettings?: any;
  filtersParams?: any;
  type?: any;
  setGetList5Way?: any;
  reRenderTableFlag?: any;
  setFiltersParams?: any;
  setDefaultUserFilter?: any;
  setUserFilterCheck?: any;
  userFilterCheck?: any;
  setReRenderUserFilter?: any;
  favoriteType?: string;
  favoriteListQuestions?: any;
  favoriteFilters?: any;
  setFavoriteFilters?: any;
  extraCompareData?: any;
}

function FilterActions(props: FilterActionsProps) {
  const {
    isOpen,
    children,
    onClose,
    onResetFilters,
    filters,
    displayFilters,
    reRenderFilterSettings,
    setReRenderFilterSettings,
    filtersParams,
    type,
    setGetList5Way,
    reRenderTableFlag,
    setFiltersParams,
    setDefaultUserFilter,
    setUserFilterCheck,
    userFilterCheck,
    setReRenderUserFilter,
    favoriteType,
    favoriteListQuestions,
    favoriteFilters,
    setFavoriteFilters,
    extraCompareData,
  } = props;

  const safeFilters = filters ?? {};
  const safeDisplayFilters = displayFilters ?? {};
  const safeFiltersParams = filtersParams ?? {};
  const canUseFavoriteFilters = typeof setReRenderFilterSettings === 'function' && reRenderFilterSettings !== undefined;
  const favoriteFiltersType = favoriteType || (type === FiveWhyType ? 'fiveWhy' : 'deviation');
  const favoriteFiltersListQuestions = favoriteListQuestions || myTasks5WayWithRelationsListName;
  const favoriteReRenderTableFlag = reRenderTableFlag || setGetList5Way;

  const clearSelectedFavoriteFilter = () => {
    if (typeof setDefaultUserFilter === "function") setDefaultUserFilter(null);
  };

  return (
    <Dialog open={isOpen} onClose={onClose} className="z-50">
      <div className="fixed inset-0 overflow-y-auto overflow-x-hidden touch-auto z-50">
        <div className="min-h-full bg-white py-6">
          <div className="pb-6 border-b border-gray-500">
            <div className="flex align-middle justify-between px-6">
              <span>Фильтры</span>

              <FlexRow className="items-center gap-2">
                {canUseFavoriteFilters && (
                  <>
                    <FavoriteButtonFilters
                      filters={(Object.keys(safeFilters).length > 0 && JSON.stringify(safeFilters)) || ""}
                      displayFilters={(Object.keys(safeDisplayFilters).length > 0 && JSON.stringify(safeDisplayFilters)) || ""}
                      reRenderFilterSettings={reRenderFilterSettings}
                      setReRenderFilterSettings={setReRenderFilterSettings}
                      filtersParams={(Object.keys(safeFiltersParams).length > 0 && JSON.stringify(safeFiltersParams)) || ""}
                      type={favoriteFiltersType}
                      extraCompareData={extraCompareData}
                    />
                    <FavoriteFiltersList
                      reRenderTableFlag={favoriteReRenderTableFlag}
                      reRenderFilterSettings={reRenderFilterSettings}
                      setReRenderFilterSettings={setReRenderFilterSettings}
                      setFiltersParams={setFiltersParams}
                      type={favoriteFiltersType}
                      filtersParams={(Object.keys(safeFiltersParams).length > 0 && JSON.stringify(safeFiltersParams)) || ""}
                      listQuestions={favoriteFiltersListQuestions}
                      setDefaultUserFilter={setDefaultUserFilter}
                      setUserFilterCheck={setUserFilterCheck}
                      userFilterCheck={userFilterCheck}
                      setReRenderUserFilter={setReRenderUserFilter}
                      favoriteFilters={favoriteFilters}
                      setFavoriteFilters={setFavoriteFilters}
                      extraCompareData={extraCompareData}
                    />
                  </>
                )}

                <button type="button" onClick={onClose}>
                  <span className="sr-only">Close</span>
                  <XMarkIcon aria-hidden="true" className="h-6 w-6" />
                </button>
              </FlexRow>

            </div>
          </div>

          <div>
            <div>{children}</div>

            <div className='flex flex-col gap-2 pt-4 px-6'>
              <button
                type='button'
                className="rounded-md px-6 py-4 shadow-md bg-[#012169] text-white"
                onClick={() => {
                  clearSelectedFavoriteFilter();
                  onClose();
                }}
              >
                Применить фильтры
              </button>

              <button
                type='button'
                className="rounded-md px-6 py-4 shadow-md bg-white text-[#012169]"
                onClick={() => {
                  clearSelectedFavoriteFilter();
                  onResetFilters();
                }}
              >
                Сбросить все фильтры
              </button>
            </div>
          </div>
        </div>
      </div>
    </Dialog>
  );
}

export default FilterActions;
